export const SET_RULE_MODAL = 'SET_RULE_MODAL';
export const SET_SUPPLEMENTAL_RULE_MODAL = 'SET_SUPPLEMENTAL_RULE_MODAL';

export const setRuleModal = (state) => (dispatch) => {
    dispatch({ type: SET_RULE_MODAL, state });
};

export const setSupplementalRuleModal = (state) => (dispatch) => {
    dispatch({ type: SET_SUPPLEMENTAL_RULE_MODAL, state });
};

export default {
    SET_RULE_MODAL,
    setRuleModal,
    SET_SUPPLEMENTAL_RULE_MODAL,
    setSupplementalRuleModal,
};
